(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-mybets-wager/assets/react/components/shared-wagers.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-mybets-wager/assets/react/components/shared-wagers.js');

'use strict';

const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const _svs$lyckoplatsen$sha = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms,
  wagersAtom = _svs$lyckoplatsen$sha.wagersAtom,
  currentWagerIdAtom = _svs$lyckoplatsen$sha.currentWagerIdAtom;
const wagerHelper = svs.lyckoplatsen.shared_mybets_wager.utils.wagerHelper;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_mybets_wager.react.components,
  FinishedWagerSummary = _svs$lyckoplatsen$com.FinishedWagerSummary,
  OngoingWagerSummary = _svs$lyckoplatsen$com.OngoingWagerSummary;
const SharedWagers = _ref => {
  let _ref$isOngoing = _ref.isOngoing,
    isOngoing = _ref$isOngoing === void 0 ? false : _ref$isOngoing;
  const selectedResultAtom = svs.lyckoplatsen.components.shared_result.jotai.atoms.selectedResultAtom;
  const wagers = useAtomValue(wagersAtom);
  const currentWagerId = useAtomValue(currentWagerIdAtom);
  const result = useAtomValue(selectedResultAtom);
  const firstWager = wagers.find(wager => wager.wagerId === currentWagerId);
  const wagersWithoutFirst = wagers.filter(wager => wager.wagerId !== currentWagerId);
  const sortedWagersWithWin = wagersWithoutFirst.filter(wager => wagerHelper.getWin(wager, result)).sort((wagerA, wagerB) => parseFloat(wagerHelper.getWin(wagerB, result).amount) - parseFloat(wagerHelper.getWin(wagerA, result).amount));
  const wagersWithoutWin = wagersWithoutFirst.filter(wager => !wagerHelper.getWin(wager, result));
  const sortedProlongableWagers = wagersWithoutWin.filter(wager => wagerHelper.getIsProlongable(wager)).sort((wagerA, wagerB) => new Date(wagerA.regWagerTime) - new Date(wagerB.regWagerTime));
  const nonProlongableWagers = wagersWithoutWin.filter(wager => !wagerHelper.getIsProlongable(wager));
  const sortedSubWagers = nonProlongableWagers.filter(wager => wager.isSubscription).sort((wagerA, wagerB) => new Date(wagerA.regWagerTime) - new Date(wagerB.regWagerTime));
  const sortedOtherWagers = nonProlongableWagers.filter(wager => !wager.isSubscription).sort((wagerA, wagerB) => new Date(wagerA.regWagerTime) - new Date(wagerB.regWagerTime));
  const sortedWagers = [firstWager, ...sortedWagersWithWin, ...sortedProlongableWagers, ...sortedOtherWagers, ...sortedSubWagers].filter(wager => Boolean(wager));
  if (isOngoing) {
    return React.createElement("div", null, React.createElement("div", {
      className: "lp-wagers margin-v-1"
    }, React.createElement("div", {
      className: "wagers-body"
    }, wagers.map(wager => React.createElement(OngoingWagerSummary, {
      key: wager.wagerId,
      wager: wager
    })))));
  }
  return React.createElement("div", {
    className: "lp-wagers margin-v-1"
  }, React.createElement("div", {
    className: "wagers-body"
  }, sortedWagers.map(wager => React.createElement(FinishedWagerSummary, {
    key: wager.wagerId,
    wager: wager
  }))));
};
setGlobal('svs.lyckoplatsen.components.shared_mybets_wager.react.components', {
  SharedWagers
});

 })(window);